module.exports = __webpack_public_path__ + "img/gh_0b8db7d66c43_344.e0480efd.jpg";